import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'pt',
  Pagination: {
    items_per_page: '/ página',
    jump_to: 'Saltar',
    jump_to_confirm: 'confirmar',
    page: '',
    prev_page: 'Página Anterior',
    next_page: 'Página Seguinte',
    prev_5: 'Recuar 5 Páginas',
    next_5: 'Avançar 5 Páginas',
    prev_3: 'Recuar 3 Páginas',
    next_3: 'Avançar 3 Páginas',
  },
  DatePicker: {
    lang: {
      locale: 'pt_PT',
      today: 'Hoje',
      now: 'Agora',
      backToToday: 'Hoje',
      ok: 'OK',
      clear: 'Limpar',
      month: 'Mês',
      year: 'Ano',
      timeSelect: 'Hora',
      dateSelect: 'Selecionar data',
      monthSelect: 'Selecionar mês',
      yearSelect: 'Selecionar ano',
      decadeSelect: 'Selecionar década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: false,
      previousMonth: 'Mês anterior (PageUp)',
      nextMonth: 'Mês seguinte (PageDown)',
      previousYear: 'Ano anterior (Control + left)',
      nextYear: 'Ano seguinte (Control + right)',
      previousDecade: 'Última década',
      nextDecade: 'Próxima década',
      previousCentury: 'Último século',
      nextCentury: 'Próximo século',
      shortWeekDays: [
        'Dom',
        'Seg',
        'Ter',
        'Qua',
        'Qui',
        'Sex',
        'Sáb',
      ],
      shortMonths: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
      placeholder: 'Data',
      rangePlaceholder: [
        'Data inicial',
        'Data final',
      ],
      monthFormat: 'MMMM',
    },
    timePickerLocale: {
      placeholder: 'Hora',
    },
  },
  TimePicker: {
    placeholder: 'Hora',
  },
  Calendar: {
    lang: {
      locale: 'pt_PT',
      today: 'Hoje',
      now: 'Agora',
      backToToday: 'Hoje',
      ok: 'OK',
      clear: 'Limpar',
      month: 'Mês',
      year: 'Ano',
      timeSelect: 'Hora',
      dateSelect: 'Selecionar data',
      monthSelect: 'Selecionar mês',
      yearSelect: 'Selecionar ano',
      decadeSelect: 'Selecionar década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: false,
      previousMonth: 'Mês anterior (PageUp)',
      nextMonth: 'Mês seguinte (PageDown)',
      previousYear: 'Ano anterior (Control + left)',
      nextYear: 'Ano seguinte (Control + right)',
      previousDecade: 'Última década',
      nextDecade: 'Próxima década',
      previousCentury: 'Último século',
      nextCentury: 'Próximo século',
      shortWeekDays: [
        'Dom',
        'Seg',
        'Ter',
        'Qua',
        'Qui',
        'Sex',
        'Sáb',
      ],
      shortMonths: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
      placeholder: 'Data',
      rangePlaceholder: [
        'Data inicial',
        'Data final',
      ],
      monthFormat: 'MMMM',
    },
    timePickerLocale: {
      placeholder: 'Hora',
    },
  },
  Table: {
    filterTitle: 'Filtro',
    filterConfirm: 'Aplicar',
    filterReset: 'Reiniciar',
    selectAll: 'Selecionar página atual',
    selectInvert: 'Inverter seleção',
    sortTitle: 'Ordenação',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancelar',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancelar',
  },
  Transfer: {
    searchPlaceholder: 'Procurar...',
    itemUnit: 'item',
    itemsUnit: 'itens',
  },
  Upload: {
    uploading: 'A carregar...',
    removeFile: 'Remover',
    uploadError: 'Erro ao carregar',
    previewFile: 'Pré-visualizar',
    downloadFile: 'Baixar',
  },
  Empty: {
    description: 'Sem resultados',
  },
};

export default localeValues;
